(function($) {
    var lastSelectedRow = 0;
    
    $.extend({
        multiRowSelectionHandler : function(event) {
            var tableRow = event.currentTarget;
            var tableObject = $(tableRow).parents('table').dataTable();
            
            if (tableRow && tableObject) {
                if (event.button !== 2) {
                    if (!event.ctrlKey && !event.shiftKey) {
                        tableObject.$('tr.row_selected').removeClass('row_selected');
                        $(tableRow).toggleClass('row_selected');
                        lastSelectedRow = $(this)[0].rowIndex;
                    } else if (event.ctrlKey && !event.shiftKey) {
                        $(tableRow).toggleClass('row_selected');
                        
                        if (tableObject.$('tr.row_selected').length > 0) {
                            lastSelectedRow = $(tableRow)[0].rowIndex;
                        } else {
                            lastSelectedRow = 0;
                        }
                    } else if (!event.ctrlKey && event.shiftKey) {
                        if (lastSelectedRow === 0) {
                            $(tableRow).toggleClass('row_selected');
                            lastSelectedRow = $(tableRow)[0].rowIndex;
                        } else {
                            tableObject.$('tr.row_selected').removeClass('row_selected');
                            var rows = $(tableObject).find('> tbody > tr');
                            var selectedRow = $(tableRow)[0].rowIndex;
                            var firstRow = Math.min(selectedRow, lastSelectedRow);
                            var lastRow = Math.max(selectedRow, lastSelectedRow);
                            
                            for (var index = firstRow; index <= lastRow; index++) {
                                $(rows[index - 1]).toggleClass('row_selected');
                            }
                        }
                    }
                } else {
                    if (!$(tableRow).hasClass('row_selected')) {
                        tableObject.$('tr.row_selected').removeClass('row_selected');
                        $(tableRow).toggleClass('row_selected');
                        lastSelectedRow = $(this)[0].rowIndex;
                    }
                }
            }
        },
        
        singleRowSelectionHandler : function(event) {
        	var tableRow = event.currentTarget;
        	var tableObject = $(tableRow).parents('table').dataTable();
        	
        	if (tableRow && tableObject) {
        		if (event.button !== 2) {
                	if ($(tableRow).hasClass('row_selected')) {
                		if (event.ctrlKey) {
	                        $(tableRow).removeClass('row_selected');
                		}
                	} else {
	                    if (!$(tableRow).hasClass('row_selected')) {
	                        tableObject.$('tr.row_selected').removeClass('row_selected');
	                        $(tableRow).addClass('row_selected');
	                    }
                    }
        		} else {
                    if (!$(tableRow).hasClass('row_selected')) {
                        tableObject.$('tr.row_selected').removeClass('row_selected');
                        $(tableRow).toggleClass('row_selected');
                    }
        		}
        	}
        },
        
        nestedTableMultiRowSelectionHandler : function(event, propagate) {
        	var element = document.elementFromPoint(event.clientX, event.clientY);
            
        	if (!$(element).hasClass('expand-image')) {
        		//only process events where the user hasn't clicked on an expand/collapse button
            	var tableRow = event.currentTarget;
	            var tableObject = $(tableRow).parents('table').dataTable();
	            
	            if (tableRow && tableObject) {
	            	var isDetailsRow = $(tableRow).children('.details').length > 0;
	            	
	                if (event.button !== 2) {
	                    if (!event.ctrlKey && !event.shiftKey) {
	                        if (!isDetailsRow) {
	                            tableObject.$('tr.row_selected').removeClass('row_selected');
		                        $(tableRow).toggleClass('row_selected');
		                        lastSelectedRow = $(event.currentTarget)[0].rowIndex;
	                        }
	                    } else if (event.ctrlKey && !event.shiftKey) {
	                        if (!isDetailsRow) {
		                        $(tableRow).toggleClass('row_selected');
		                        
		                        if (tableObject.$('tr.row_selected').length > 0) {
		                            lastSelectedRow = $(tableRow)[0].rowIndex;
		                        } else {
		                            lastSelectedRow = 0;
		                        }
	                        }
	                    } else if (!event.ctrlKey && event.shiftKey) {
	                        if (lastSelectedRow === 0) {
		                        if (!isDetailsRow) {
		                            $(tableRow).toggleClass('row_selected');
		                            lastSelectedRow = $(tableRow)[0].rowIndex;
		                        }
	                        } else {
	                            tableObject.$('tr.row_selected').removeClass('row_selected');
	                            var rows = $(tableObject).find('> tbody > tr');
	                            var selectedRow = $(tableRow)[0].rowIndex;
	                            var firstRow = Math.min(selectedRow, lastSelectedRow);
	                            var lastRow = Math.max(selectedRow, lastSelectedRow);
	                            
	                            for (var index = firstRow; index <= lastRow; index++) {
	                            	var currentRow = $(rows[index - 1]);
	                            	if (currentRow.children('.details').length === 0) {	                            	
	                            		currentRow.toggleClass('row_selected');
	                            	}
	                            }
	                        }
	                    }
	                } else {
	                    if (!$(tableRow).hasClass('row_selected')) {
	                        if (!isDetailsRow) {
		                        tableObject.$('tr.row_selected').removeClass('row_selected');
		                        $(tableRow).toggleClass('row_selected');
		                        lastSelectedRow = $(event.currentTarget)[0].rowIndex;
	                        }
	                    }
	                }
	            }
            }
        	
        	if (!propagate) {
        	    event.stopPropagation();
        	}
        },
        
        nestedTableMultiRowSelectionHandlerPropagator : function(event) {
            $.nestedTableMultiRowSelectionHandler(event, true);
        },
        
        nestedTableSingleRowSelectionHandler : function(event) {
        	var tableRow = event.currentTarget;
        	var tableObject = $(tableRow).parents('table').dataTable();
        	var element = document.elementFromPoint(event.clientX, event.clientY);
        	
        	if (!$(element).hasClass('expand-image')) {
        		// Don't select rows that contain nested tables
	        	if (tableRow && tableObject && $(tableRow).find('.nesting-table').length === 0) {
	        		if (event.button !== 2) {
	                	if ($(tableRow).hasClass('row_selected')) {
	                		if (event.ctrlKey) {
		                        $(tableRow).removeClass('row_selected');
	                		}
	                	} else {
		                    if (!$(tableRow).hasClass('row_selected')) {
		                        $('tr.row_selected').removeClass('row_selected');
		                        $(tableRow).addClass('row_selected');
		                    }
	                    }
	        		} else {
	                    if (!$(tableRow).hasClass('row_selected')) {
	                        $(tableRow).removeClass('row_selected');
	                    }
	        		}
	        	}
        	}
        },
        
    });
    
})(jQuery);